// ============================================
// UTILS: Mappers - Funciones de mapeo
// ============================================
// Archivo: src/utils/mappers.js

// ✅ CORREGIDO: Mapea desde PostgreSQL al frontend
export const mapPlantFromBackend = (p) => ({
  id: p.id,
  code: p.code || p.codigo || '',           // PostgreSQL: code | SQLite: codigo
  name: p.name || p.nombre || '',           // PostgreSQL: name | SQLite: nombre
  location: p.location || p.direccion || '', // PostgreSQL: location | SQLite: direccion
  manager: p.manager || p.jefe || '',       // PostgreSQL: manager | SQLite: jefe
  contact: p.contact || p.contacto || '',   // ✅ CORREGIDO: contact → contact
  schedule: p.schedule || '08:00-20:00',    // ✅ CORREGIDO: Usa el valor de la BD
  lines: p.lines || 4,
  company_id: p.company_id ?? null,
  status: [],
  active: true
});

// ✅ CORREGIDO: Mapea desde frontend a PostgreSQL
export const mapPlantToBackend = (p) => ({
  code: p.code,
  name: p.name,
  location: p.location || '',
  manager: p.manager || '',
  contact: p.contact || '',           // ✅ CORREGIDO: contact → contact
  schedule: p.schedule || '08:00-20:00',
  lines: parseInt(p.lines || 4),
  status: JSON.stringify(p.status || []),
  active: p.active !== undefined ? p.active : true
});

// ✅ CORREGIDO: Mapea equipments desde PostgreSQL
export const mapEquipmentFromBackend = (e) => {
  if (!e) return null;
  
  const mapped = {
    id: e.id,
    plantId: e.plant_id || e.plantId || e.plantid,
    line: e.line || 'L1',
    code: e.code || '',
    name: e.name || e.nombre || '',
    manufacturer: e.manufacturer || '',
    model: e.model || '',
    serial: e.serial ||  '',
    installdate: e.installdate || '',
    supplier: e.supplier || '',
    cost: parseInt(e.cost || 0),
    freq: parseInt(e.frecuencia || 0),
    status: e.status || 'operativo',
    company_id: e.company_id ?? null
  };
  
  return mapped;
};

// ✅ CORREGIDO: Mapea equipments desde frontend a PostgreSQL
export const mapEquipmentToBackend = (e) => ({
  plant_id: e.plantId || e.plantid,
  code: e.code || '',
  name: e.name,
  manufacturer: e.manufacturer || '',
  model: e.model || '',
  serial: e.serial || '',
  cost: parseInt(e.cost || 0),
  line: e.line || 'L1',
  status: e.status || 'operativo',
  installdate: e.installdate || null,
  supplier: e.supplier || ''
});

export const mapMaintenanceToBackend = (m) => ({
  equipment_id: m.equipmentId,
  tipo: m.type,
  fecha_mantenimiento: m.date,
  descripcion: m.description || '',
  tecnico: m.provider || '',
  costo: parseFloat(m.cost) || 0
});

export const mapCalibrationFromBackend = (c) => ({
  id: c.id,
  equipmentId: c.equipment_id,
  plantId: c.plant_id,
  date: c.fecha_calibracion || c.date,
  provider: c.tecnico || c.provider,
  certificateNumber: c.numero_certificado || c.certificate_number,
  validUntil: c.proxima_calibracion || c.valid_until,
  result: c.resultado || c.result,
  certificateUrl: c.archivo_path || c.certificate_url,
  equipmentName: c.equipment_name,
  plantName: c.plant_name,
  createdAt: c.created_at
});